<script module lang="ts">
  import type { CardColumnsStoryblokProps } from './card-columns.types';
</script>

<script lang="ts">
  import { Section } from '@agapi/ui/section';
  import { storyblokEditable, StoryblokComponent } from '@storyblok/svelte';
  import { css } from '@agapi/ui/panda/css';
  import { cardColumnsStyles } from './card-columns.styles';

  const { blok }: CardColumnsStoryblokProps = $props();

  const styles = cardColumnsStyles.raw({
    columnCount: blok.columnCount
  });
</script>

<Section
  use={[[storyblokEditable, blok]]}
  colorVariant={blok.colorVariant}
  rootStyles={css.raw({ py: blok.verticalSpacing })}
>
  {#if blok.title || blok.subtitle}
    <div class={css(styles.header)}>
      {#if blok.title}
        <h2 class={css({ textStyle: 'h2', textAlign: blok.titleAlignment })}>{blok.title}</h2>
      {/if}
      {#if blok.subtitle}
        <p class={css({ textStyle: 'body', textAlign: blok.titleAlignment })}>{blok.subtitle}</p>
      {/if}
    </div>
  {/if}

  <div class={css(styles.grid)}>
    {#each blok.columns as column}
      <StoryblokComponent blok={column} />
    {/each}
  </div>
</Section>